exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".car-container {\n  border: 1px solid #e3e3e3;\n  padding: 16px;\n  border-radius: 8px;\n  height: 122px;\n}\n\n.car-container .title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: left;\n  color: #0b0b0a;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n}\n\n.car-container .price {\n  color: #0b0b0a;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 60px;\n  margin-right: 8px;\n}\n\n.car-container .unit {\n  color: #929292;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: left;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Dashboard/OverviewWholeBank/components/Car/Car.style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Dashboard/OverviewWholeBank/components/Car/Car.style.scss
// module chunks = 0